import { useState } from 'react';
import { Container, Row, Col, Button, Badge } from 'react-bootstrap';
import { motion } from 'motion/react';
import brandData from '../../data/brandData.json';

const Showcase = () => {
  const [activeFilter, setActiveFilter] = useState('All')

  const getImage = (imageName) => {
    return require(`../../assets/${imageName}`)
  }

  const { showcase } = brandData

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1 }
    }
  }

  const itemVariants = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: { duration: 0.4, ease: "easeOut" }
    }
  }

  return (
    <section id="brand-work" className="section-lg overflow-hidden">
      <Container>
        <Row className="mb-5">
          <Col xs={12} className="text-center">
            <motion.h2 className="text-success fw-semibold mb-2"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
            >
              {showcase.title}
            </motion.h2>
            <motion.p className="text-dark mb-3"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.1 }}
            >
              {showcase.subtitle}
            </motion.p>
            <motion.div className="d-inline-flex flex-wrap gap-2"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
            >
              {showcase.filters.map((filter) => (
                <motion.div key={filter} whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
                  <Button size="sm" variant={activeFilter === filter ? 'success' : 'outline-success'} onClick={() => setActiveFilter(filter)}>
                    {filter}
                  </Button>
                </motion.div>
              ))}
            </motion.div>
          </Col>
        </Row>
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          <Row className="g-3">
            {showcase.items.map((item) => (
              <Col xs={6} lg={3} key={item.id}>
                <motion.div
                  variants={itemVariants}
                  whileHover={{ y: -8, transition: { duration: 0.3 } }}
                >
                  <div className="work-item ratio ratio-1x1 rounded-3 overflow-hidden border-0">
                    <img src={getImage(item.image)} className="w-100 h-100 object-fit-cover" alt="work" />
                    <div className="work-overlay">
                      <Badge bg="success">{item.category}</Badge>
                    </div>
                  </div>
                  <div className="mt-2">
                    <h6 className="mb-1">{item.title}</h6>
                    <small className="text-secondary">{item.description}</small>
                  </div>
                </motion.div>
              </Col>
            ))}
          </Row>
        </motion.div>
      </Container>
    </section>
  )
}

export default Showcase;
